module.exports = __webpack_public_path__ + "static/media/logo.7afd6e3f.jpg";